import React from "react";
import { Button, Typography } from "@material-ui/core";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import PaperIcon from "assets/PaperIcon";

const useStyles = makeThemedStyles("KPIInfo", (theme) => ({
  root: {
    background: "rgba(241, 241, 242, 0.41)",
    fontSize: "1.145em !important",
    border: "1.2em",
    width: "100%",
    minHeight: "18.4em",
    padding: "2.2em 1.6em",
    borderRadius: "1.2em",
  },
  header: {
    marginBottom: "1.8em",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    margin: "0 1.25em",
    color: "rgba(63, 69, 79, 1)",
    fontSize: "1.6em",
    lineHeight: "1.5em",
    letterSpacing: "0.05625px",
    fontWeight: 600,
  },
  icon: {
    height: "3.2em",
    width: "3.2em",
    borderRadius: ".8em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(16, 41, 117, 1)",
    "& svg": {
      fill: "rgb(255, 255, 255)",
    },
  },
  viewMore: {
    color: "rgba(14, 156, 240, 1)",
    fontSize: "1.4em",
    lineHeight: "1.428em",
    letterSpacing: "0.05625px",
    padding: "0.714em 1.142em",
    background: "transparent",
    textTransform: "unset",
  },
  container: {
    display: "flex",
  },
  description: {
    marginRight: ".8em",
    maxWidth: "calc(100% / 4)",
    width: "100%",
    "&:last-child": {
      marginRight: 0,
    },
    "&.rtl": {
      marginLeft: ".8em",
      marginRight: "unset",
      "&:last-child": {
        marginLeft: 0,
      },
    },
  },
  descriptionLabel: {
    fontSize: "1.2em",
    lineHeight: "1.66em",
    fontWeight: 700,
    color: "rgba(16, 41, 117, 1)",
    opacity: 0.8,
    letterSpacing: "0.05625px",
    textTransform: "uppercase",
    " mix-blend-mode": "normal",
  },
  descriptionText: {
    color: "rgba(63, 69, 79, 1)",
    fontSize: "1.3em",
    lineHeight: "1.384",
    letterSpacing: "0.05625px",
    fontWeight: 500,
    whiteSpace: "pre-line",
  },
}));

type IKPIInfoItem = { label: string; text: string | React.ReactNode };

const MeasureInfo = (
  props: React.PropsWithChildren<{
    items: IKPIInfoItem[];
    title: string;
    moreText?: string;
    onMore?: () => void;
  }>
) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <div className={classes.container} style={{ alignItems: "center" }}>
          <div className={classes.icon}>
            <PaperIcon size={20} fillColor="white" />
          </div>

          <Typography className={classes.title}>{props.title}</Typography>
        </div>
        {props.items.length > 4 ? (
          <Button
            variant="text"
            className={classes.viewMore}
            onClick={props.onMore}
          >
            {props.moreText || "View More"}
          </Button>
        ) : null}
      </div>
      <div className={classes.container}>
        {props.items.slice(0, 4).map((item, index) => {
          return (
            <div className={classes.description} key={index}>
              <Typography className={classes.descriptionLabel}>
                {item.label}
              </Typography>
              <div className={classes.descriptionText}>{item.text}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MeasureInfo;
